import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getWarrantyChassis = (chassis, campaign) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/vehicle/${chassis}?campaign=${campaign}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTY_CHASSIS,
        ActionTypes.FETCHED_TWC_WARRANTY_CHASSIS,
        [ActionTypes.FETCHED_TWC_WARRANTY_CHASSIS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addWarrantyChassis = (chassis, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/vehicle/${chassis}`,
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_TWC_WARRANTY_CHASSIS,
        [
          ActionTypes.ADDED_TWC_WARRANTY_CHASSIS,
          MessageActions.addMessageBoxInfo('Registro de vehículo exitoso'),
        ],
        [
          ActionTypes.ADDED_TWC_WARRANTY_CHASSIS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const clearWarrantyChassis = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY_CHASSIS,
  };
};
